import { Mark, Node, mergeAttributes } from "@tiptap/core";

export const MergeField = Node.create({
  name: "mergeField",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,
  addAttributes() {
    return {
      key: { default: null }, label: { default: null }, dataType: { default: "string" },
      format: { default: null }, sourceType: { default: "matter-context" }, resolved: { default: false },
    };
  },
  parseHTML() { return [{ tag: "span[data-merge-field]" }]; },
  renderHTML({ node, HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes, {
      "data-merge-field": node.attrs.key,
      "data-resolved": String(Boolean(node.attrs.resolved)),
      class: `agreement-token${node.attrs.resolved ? "" : " is-unresolved"}`,
      contenteditable: "false",
    }), node.attrs.label || node.attrs.key || "Unresolved field"];
  },
  addCommands() {
    return { insertMergeField: (attrs) => ({ commands }) => commands.insertContent({ type: this.name, attrs }) };
  },
});

export const AgreementProvision = Node.create({
  name: "agreementProvision",
  group: "block",
  content: "block+",
  defining: true,
  isolating: true,
  addAttributes() {
    return {
      provisionId: { default: null }, parentProvisionId: { default: null }, categoryId: { default: null },
      level: { default: 0 }, sortOrder: { default: 0 }, numberingStyle: { default: "decimal" },
      displayNumber: { default: "" }, status: { default: "draft" },
    };
  },
  parseHTML() { return [{ tag: "section[data-agreement-provision]" }]; },
  renderHTML({ node, HTMLAttributes }) {
    return ["section", mergeAttributes(HTMLAttributes, {
      "data-agreement-provision": node.attrs.provisionId,
      "data-number": node.attrs.displayNumber,
      class: "agreement-provision",
    }), 0];
  },
});

export const ProvisionReference = Node.create({
  name: "provisionReference",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,
  addAttributes() {
    return {
      targetProvisionId: { default: null }, referenceStyle: { default: "paragraph" },
      includeTitle: { default: false }, resolvedText: { default: "Unresolved reference" }, resolved: { default: false },
    };
  },
  parseHTML() { return [{ tag: "span[data-provision-reference]" }]; },
  renderHTML({ node, HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes, {
      "data-provision-reference": node.attrs.targetProvisionId,
      class: `agreement-reference${node.attrs.resolved ? "" : " is-unresolved"}`,
      contenteditable: "false",
    }), node.attrs.resolvedText || "Unresolved reference"];
  },
  addCommands() {
    return { insertProvisionReference: (attrs) => ({ commands }) => commands.insertContent({ type: this.name, attrs }) };
  },
});

export const DefinedTerm = Mark.create({
  name: "definedTerm",
  addAttributes() {
    return { termId: { default: null }, term: { default: null }, definitionProvisionId: { default: null } };
  },
  parseHTML() { return [{ tag: "span[data-defined-term]" }]; },
  renderHTML({ HTMLAttributes }) { return ["span", mergeAttributes(HTMLAttributes, { "data-defined-term": HTMLAttributes.term, class: "agreement-defined-term" }), 0]; },
});

function blockNode(name, tag, label) {
  return Node.create({
    name,
    group: "block",
    atom: true,
    selectable: true,
    addAttributes() { return { config: { default: null } }; },
    parseHTML() { return [{ tag: `${tag}[data-agreement-block]` }]; },
    renderHTML({ HTMLAttributes }) {
      return [tag, mergeAttributes(HTMLAttributes, { "data-agreement-block": name, class: `agreement-${name}`, contenteditable: "false" }), label];
    },
  });
}

export const SignatureBlock = blockNode("signatureBlock", "div", "Signature block");
export const NotaryBlock = blockNode("notaryBlock", "div", "Notary acknowledgment");

export const PageBreak = Node.create({
  name: "pageBreak",
  group: "block",
  atom: true,
  selectable: true,
  parseHTML() { return [{ tag: "div[data-page-break]" }]; },
  renderHTML({ HTMLAttributes }) { return ["div", mergeAttributes(HTMLAttributes, { "data-page-break": "true", class: "agreement-page-break", contenteditable: "false" }), "Page break"]; },
  addCommands() { return { setPageBreak: () => ({ commands }) => commands.insertContent({ type: this.name }) }; },
});

export const agreementExtensions = [MergeField, AgreementProvision, ProvisionReference, DefinedTerm, SignatureBlock, NotaryBlock, PageBreak];
